import { FC } from "react";
import { Modal } from 'antd';


const CommonModal: FC<any> = (props) => {

    const {open , children , onCancel, closable=true , width = 590} = props;

    return (
        <Modal open={open} onCancel={onCancel} width={width} closable={closable} footer={false}>
            {children}
        </Modal>
    );
}


export default CommonModal;
